export default __webpack_public_path__ + "static/media/Mask of the Outer Dark.7aca67e6.jpg";